module.exports = __webpack_public_path__ + "static/media/character-outline-body.063ebb0e.png";